import React from "react";
import { Helmet } from "react-helmet";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import HeaderThree from "../../../components/header/HeaderThree";

import FancyTextBlockThree from "../../../components/fancy-text-block/FancyTextBlockThree";
import ProductsCore from "../../../assets/Sub-component/ProductsCore";

import corporate from "../../../assets/Products-icon/Raiden_verse/How-we-help-IndustryLeaders/Corporate.svg";
import Education from "../../../assets/Products-icon/Raiden_verse/How-we-help-IndustryLeaders/Education.svg";
import Healthcare from "../../../assets/Products-icon/Raiden_verse/How-we-help-IndustryLeaders/Healthcare.svg";
import Retail from "../../../assets/Products-icon/Raiden_verse/How-we-help-IndustryLeaders/Retail.svg";
import { Link } from "react-router-dom";
import launchingimage from '../../../assets/Launchingimage.png'
const RaidenVerse = () => {
  const keyfeature = [
    {
      name: "Retail Evolution",
      description:
        "Raiden verse has enabled leading retail brands to offer virtual stores that provide revolutionary shopping experiences.",
      icon: Retail,
      name2: "Education Empowerment",
      description2:
        "  Raiden verse transforms knowledge into an experience by establishing immersive environments that remove obstacles to learning within the classroom.",
      icon2: Education,
      name3: "",
      description3: " ",
      icon3: "",
      name4: " Healthcare Revolution",
      description4:
        " Raiden verse's immersive simulations and virtual environments for improved learning and therapy have transformed medical training and patient care in the healthcare industry.",
      icon4: Healthcare,
      name5: "Corporate Collaboration",
      description5:
        "   Our platform makes it possible for distant teams to collaborate easily across different virtual workspaces, establishing Raiden verse as an innovation and collaboration hub for business clients.",
      icon5: corporate,
      name6: "",
      description6: "  ",
      icon6: "",
    },
  ];

  return (
    <>
     <img 
       src={launchingimage} 
        className="Bg-image "
       alt="Launching"
     />
    <div className="main-page-wrapper overflow-hidden">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />

      <div
        className=" container  d-flex align-items-center justify-content-center flex-column  topheader-margin"
        style={{ minHeight: "100vh" }}
      >
        <h1 className="h1-heading fw-bold text-center">Raiden Verse</h1>
        <h2 className="my-2 h2-heading lh-sm pt-1">
          {" "}
          Stepping Ahead with Next-Generation Metaverse Uses
        </h2>
        <p className="h1-para text-center mt-4 mb-4">
          Establishing the benchmark for innovative immersive metaverse
          solutions is essential to creating next-generation metaverse
          applications.
        </p>
        <Link to="/request-quote">
          <button
            className="h3-para btn btn-primary mt-3 py-3 px-3 btn-gradient border-0  rounded-4"
            style={{ fontSize: 18 }}
          >
            Get Your Free Quote
          </button>
        </Link>
      </div>
      <div className=" bg-light">
        <div className=" container pt-50">
          <div className=" row mb-80 marb">
            <h2 className="h2-heading text-center text-lg-start col-12 col-lg-6  ">
              {" "}
              Why Raiden verse
            </h2>
            <p className="h3-para col-12 col-lg-6 mt-2 mt-lg-0">
              Raiden verse, we're powered by a passion for virtual reality's next
              frontier. Our team of technologists and creatives uses their
              extensive knowledge of futuristic technology to innovate in the
              metaverse, turning bold concepts into engrossing, immersive
              worlds.
            </p>
          </div>
        </div>

        {/* Key Features */}
        <div className="fancy-text-block-three bg-light mt-80">
          <div className="container">
            <h2 className="text-center h2-heading mb-3 pb-lg-3">
              How we help Industry Leaders
            </h2>
            <div className="row">
              <div className="col-xl-11 m-auto">
                <FancyTextBlockThree keyfeature={keyfeature[0]} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className=" container pt-50">
        <div className=" row mb-80 marb">
          <h2 className="h2-heading text-center text-lg-start col-12 col-lg-6  ">
            {" "}
            WHAT WE DO
          </h2>
          <p className="h3-para col-12 col-lg-6 mt-2 mt-lg-0">
            Raiden verse's AI-powered metaverse platform is pushing the
            boundaries of digital technology and changing the way businesses
            interact with virtual environments by providing captivating,
            futuristic experiences.
          </p>
        </div>
      </div>

      <div>
        <ProductsCore />
      </div>

      {/* footer */}
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>

        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default RaidenVerse;
